import { render, staticRenderFns } from "./UiRole.vue?vue&type=template&id=160a636e"
import script from "./UiRole.vue?vue&type=script&lang=js"
export * from "./UiRole.vue?vue&type=script&lang=js"
import style0 from "./UiRole.vue?vue&type=style&index=0&id=160a636e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports